'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setMessage = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _set = require('transmute/set');

var _set2 = _interopRequireDefault(_set);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Set a message in a ThreadHistory
 *
 * @param {string} messageKey
 * @param {PubNubMessageRecord} message
 * @param {ThreadHistory} threadHistory
 * @returns {ThreadHistory}
 */
var setMessage = exports.setMessage = (0, _curry2.default)(function (messageKey, message, threadHistory) {
  return threadHistory.updateIn(_keyPaths.MESSAGES, (0, _set2.default)(messageKey, message));
});